import { DownloadBookingFilters } from '../../../utils/downloadFilters';
import { FILTERABLE_COLUMNS } from '../constants/filterableColumns';

// An ag-grid set-filter model entry: { values: [...] } where each value is
// either a raw string or an object exposing a `value` field.
type SetFilterValue = string | { value?: string };
type FilterModel = Record<string, { values?: SetFilterValue[] } | undefined>;

const readSelectedValues = (
  filterModel: FilterModel,
  column: string
): string[] =>
  (filterModel[column]?.values ?? [])
    .map((v) => (typeof v === 'string' ? v : v.value ?? ''))
    .filter((v): v is string => v !== '');

/**
 * Extracts the brand/slot/GTM selections from an ag-grid filter model so the
 * export download can request only the filtered bookings. A null/empty filter
 * model yields empty arrays (i.e. no narrowing → export all).
 */
export const extractBackendFilters = (
  filterModel: FilterModel | null | undefined
): DownloadBookingFilters => {
  if (!filterModel) {
    return { brandNames: [], slotNames: [], gtmStatuses: [] };
  }
  return {
    brandNames: readSelectedValues(filterModel, FILTERABLE_COLUMNS.BRAND),
    slotNames: readSelectedValues(filterModel, FILTERABLE_COLUMNS.SLOT_NAMES),
    gtmStatuses: readSelectedValues(filterModel, FILTERABLE_COLUMNS.GTM_STATUS),
  };
};
